import { ChangeDetectionStrategy, Component } from '@angular/core';
import { openClose } from '@core/animations/animations';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { MatterMortgageWithAssociations } from '@models/mortgage';
import { Select } from '@ngxs/store';
import { MatterMortgagesState } from '@state/matter/matter_mortgages/matter-mortgages.state';
import { Observable } from 'rxjs/internal/Observable';
import { CALL_TO_ACTION_TYPES } from 'src/app/ui/note/note.component';
import { TestHooks } from './mms-mortgage-warning.hooks';

@Component({
	selector: 'app-mms-mortgage-warning',
	templateUrl: './mms-mortgage-warning.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	animations: [openClose()],
	standalone: false,
})
export class MmsMortgageWarningComponent {
	testHooks = TestHooks;
	CALL_TO_ACTION_TYPES = CALL_TO_ACTION_TYPES;

	@SelectSnapshot(SelectedMatter.id) matterId: string;
	@SelectSnapshot(SelectedMatter.titleInsuranceThirdPartyId)
	titleInsuranceThirdPartyId: string;
	@Select(MatterMortgagesState.hasMMSMortgage) hasMMSMortgage$: Observable<
		MatterMortgageWithAssociations[]
	>;
}
